{
  "REGISTER": {
    "TRY_WOOT": "Ustvari račun",
    "GET_STARTED": "Get started with Chatwoot",
    "TITLE": "Registrirajte se",
    "TESTIMONIAL_HEADER": "Le še en korak, da napredujete",
    "TESTIMONIAL_CONTENT": "Ste le korak stran od tega, da pritegnete svoje stranke, jih obdržite in najdete nove.",
    "TERMS_ACCEPT": "Z ustvarjanjem računa se strinjate z našimi <a href=\"https://www.chatwoot.com/terms\">Pogoji uporabe</a> in z <a href=\"https://www.chatwoot.com/privacy-policy\">Politiko zasebnosti</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Prijavite se z Googlom"
    },
    "COMPANY_NAME": {
      "LABEL": "Ime podjetja",
      "PLACEHOLDER": "Vnesite ime vašega podjetja. Npr. Wayne Enterprises",
      "ERROR": "Ime podjetja je prekratko."
    },
    "FULL_NAME": {
      "LABEL": "Polno ime",
      "PLACEHOLDER": "Vnesite svoje polno ime. Npr. Bruce Wayne",
      "ERROR": "Polno ime je prekratko."
    },
    "EMAIL": {
      "LABEL": "Službena e-pošta",
      "PLACEHOLDER": "Vnesite svoj službeni e-poštni naslov. Npr. bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Vnesite veljaven službeni e-poštni naslov."
    },
    "PASSWORD": {
      "LABEL": "Geslo",
      "PLACEHOLDER": "Geslo",
      "ERROR": "Geslo je prekratko.",
      "IS_INVALID_PASSWORD": "Geslo mora vsebovati vsaj 1 veliko črko, 1 malo črko, 1 številko in 1 poseben znak.",
      "REQUIREMENTS_LENGTH": "At least 6 characters long",
      "REQUIREMENTS_UPPERCASE": "At least one uppercase letter",
      "REQUIREMENTS_LOWERCASE": "At least one lowercase letter",
      "REQUIREMENTS_NUMBER": "At least one number",
      "REQUIREMENTS_SPECIAL": "At least one special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Potrdite geslo",
      "PLACEHOLDER": "Potrdite geslo",
      "ERROR": "Gesli se ne ujemata."
    },
    "API": {
      "SUCCESS_MESSAGE": "Registration Successful",
      "ERROR_MESSAGE": "Ni bilo mogoče vzpostaviti povezave s strežnikom. Prosimo poskusite ponovno."
    },
    "SUBMIT": "Ustvari račun",
    "HAVE_AN_ACCOUNT": "Že imate račun?",
    "VERIFY_EMAIL": {
      "TITLE": "Check your inbox",
      "DESCRIPTION": "We sent a verification link to {email}. Click the link to verify your email and get started.",
      "RESEND": "Ponovno pošlji potrditveni e-poštni naslov",
      "RESEND_SUCCESS": "Verification email sent. Please check your inbox.",
      "RESEND_ERROR": "Could not send verification email. Please try again."
    }
  }
}
